import { render } from "./page-list.vue?vue&type=template&id=7d15a216&ts=true"
import script from "./page-list.vue?vue&type=script&lang=ts"
export * from "./page-list.vue?vue&type=script&lang=ts"

import "./page-list.vue?vue&type=style&index=0&id=7d15a216&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__